import { call, put, takeLatest } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import { t } from 'i18next'
import apiCall from '../helpers/apiCall'
import { DELETE } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  DELETE_CHANNEL_ACTIVATION,
  DELETE_CHANNEL_ACTIVATION_FAILURE,
  DELETE_CHANNEL_ACTIVATION_SUCCESS,
  FETCH_CHANNELS
} from 'src/redux/integrationsReducer'
import { SHOW_TOAST } from 'src/redux/toastReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* DeleteChannelActivationFlow(action: PayloadAction<{ id: number }>): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    yield call(apiCall, {
      endpoint: `/dealers_api/channel_activations/${action.payload.id}`,
      api: 'market-api',
      method: DELETE,
      params: {}
    })
    yield put(DELETE_CHANNEL_ACTIVATION_SUCCESS())
    yield put(SHOW_TOAST({ message: t('integrations_screen.disconnect_success') }))
    yield put(FETCH_CHANNELS())
  } catch (error) {
    yield put(DELETE_CHANNEL_ACTIVATION_FAILURE())
    yield put(SHOW_TOAST({ message: t('integrations_screen.disconnect_error') }))
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* DeleteChannelActivationSaga(): Generator<any, void, any> {
  yield takeLatest(DELETE_CHANNEL_ACTIVATION, DeleteChannelActivationFlow)
}
